import { render } from "./iconFilter.vue?vue&type=template&id=a0509340"
import script from "./iconFilter.vue?vue&type=script&lang=js"
export * from "./iconFilter.vue?vue&type=script&lang=js"
script.render = render

export default script